import { render, staticRenderFns } from "./AsiCurrencyAutocomplete.vue?vue&type=template&id=1d9a6b20&scoped=true"
import script from "./AsiCurrencyAutocomplete.vue?vue&type=script&lang=ts"
export * from "./AsiCurrencyAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a6b20",
  null
  
)

export default component.exports